import React, { useState } from 'react';// eslint-disable-line
import PropTypes from "prop-types";

import "./TableNameAvatarCell.scss";
import { BLACK } from '../../styles/shared/colors';
import { PlayerBadge } from '../..';


const TableNameAvatarCell = ({ firstName, lastName, avatarBgColor, avatar }) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = ()=> {
    setImageError(true);
  }

  return (
    <div className="table-name-avatar-cell">
      {avatar && !imageError ?
        <img className="table-name-avatar-cell__image" src={avatar} alt="" onError={handleImageError}/> :
        <PlayerBadge firstName={firstName} lastName={lastName} color={avatarBgColor} fontSize={16}/>}
      <span className="table-name-avatar-cell__name">{`${firstName} ${lastName}`}</span>
    </div>
  );
};

TableNameAvatarCell.propTypes = {
  avatar: PropTypes.string,
  avatarBgColor: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string
};

TableNameAvatarCell.defaultProps = {
  avatar: "",
  avatarBgColor: BLACK,
  firstName: "",
  lastName: ""
};

export default TableNameAvatarCell;